import { Card, CardMedia, CardContent, Grid, Button, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import team from "../resources/team";
import { BRAND_NAME } from "../../config/constants";

const PREFIX = 'Team';

const classes = {
  root: `${PREFIX}-root`,
  media: `${PREFIX}-media`
};

const Root = styled('div')({
  [`& .${classes.root}`]: {
    maxWidth: 350,
    marginRight: 10,
    marginLeft: 10,
    marginTop: 50,
    textAlign: "left",
  },
  [`& .${classes.media}`]: {
    height: 350,
    width: 350,
  },
});

function Team() {


  return (
    <Root className="team">
      <Grid container style={{ textAlign: "center", justifyContent: "center" }}>
        <Grid item xs={12}>
          <br></br>
          <Typography style={{ fontSize: "2.5rem", fontFamily: "Raleway" }}>
            {`${BRAND_NAME} - Team`}
          </Typography>
        </Grid>

        {team.map((info, index) => {
          return (
            <div key={index}>
              <Card className={classes.root}>
                <CardMedia className={classes.media} image={info.image} />
                <CardContent>
                  <Typography
                    component="h2"
                    style={{ fontSize: 20, fontFamily: "Raleway" }}
                  >
                    {info.Name}
                  </Typography>

                  {info.About_half}
                  <br></br>
                </CardContent>

                <Button
                  href={`/team/${info.Name}`}
                  style={{
                    float: "right",
                    height: 20,
                    width: 100,
                    textTransform: "None",
                  }}
                >
                  Read More
                </Button>

                <br></br>
              </Card>
            </div>
          );
        })}
      </Grid>
    </Root>
  );
}

export default Team;
